import React from 'react';
import classNames from 'classnames';
import styles from './select.module.css.js';

const Select = ({ children, disabled, id, name, onChange, onBlur, value, size = 'medium', error, }) => {
    const handleChange = (e) => {
        onChange(e.target.value);
    };
    const handleBlur = () => {
        if (onBlur)
            onBlur();
    };
    return (React.createElement("div", { className: classNames('bc-select', styles.wrapper, {
            [styles[size]]: size,
            [styles['disabled']]: disabled,
            [styles['error']]: error,
        }), "data-testid": 'select-wrapper' },
        React.createElement("select", { className: styles.select, "data-testid": 'select', disabled: disabled, id: id, name: name, onChange: handleChange, onBlur: handleBlur, value: value }, children),
        React.createElement("i", { className: "bc-icon bc-icon-arrow-down", "data-testid": "icon" })));
};

export { Select };
